export default "__VITE_ASSET__DiqsSKUM__"